import Vue from 'vue'
import VueI18n from 'vue-i18n'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN' // element-ui lang
import elementJaLocale from 'element-ui/lib/locale/lang/ja'
import enLocale from './en'
import zhLocale from './zh'
import jaLocale from './ja'
import { language, localLanguage } from '@/common/storage'
import isMaterialWarehouse from '@/common/is-warehouse.js'
import Url from 'url-parse'

Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale,
  },
  'zh-cn': {
    ...zhLocale,
    ...elementZhLocale,
  },
  ja: {
    ...jaLocale,
    ...elementJaLocale,
  },
}

const languages = ['zh-cn', 'en', 'ja']
const fallbackLocale = isMaterialWarehouse() ? 'zh-cn' : 'en'

const setFallbackLocale = () => {
  language.set(fallbackLocale)
}

const getLanguage = () => {
  // 优先使用 url 上的 lang 参数
  const query =
    (new Url(window.location.hash.replace('#', ''), true) || {}).query || {}

  if (query.lang) {
    const lang = query.lang.toLocaleLowerCase()
    // 如果是支持的语言直接赋值
    if (languages.some((item) => item === lang)) {
      language.set(lang)
    } else if (lang.indexOf('zh') === 0 || lang === 'cn') {
      // zh 起始字符串认为是中文
      language.set('zh-cn')
    } else {
      // 其他情况根据不同平台使用不同的语言
      setFallbackLocale()
    }
    return localLanguage.get()
  }

  const currentLanguage = localLanguage.get()
  // 没有默认语言或不支持的语言
  if (!currentLanguage || !languages.some((item) => item === currentLanguage)) {
    setFallbackLocale()
  }

  return localLanguage.get()
}

const i18n = new VueI18n({
  locale: getLanguage(), // set locale
  fallbackLocale,
  messages, // set locale messages
  silentTranslationWarn: true, // 去除国际化警告
})

export const t = (...args) => i18n.t(...args)

export default i18n
